import { Component, Input, OnInit } from '@angular/core';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';

@Component({
  selector: 'app-cooking-story-tutorial-kitchen',
  templateUrl: './cooking-story-tutorial-kitchen.component.html',
  styles: [
    `
      .container {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
      }
      .kitchen,
      .members {
        font-family: 'Vazir-Bold' !important;
        font-size: 22px;
        color: white;
        padding: 0 24px;
        position: absolute;
        top: 30%;
      }
      .button-holder {
        position: fixed;
        bottom: 0px;
        width: calc(100vw - 48px);
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        height: 103px;
        justify-content: space-between;
      }
      .button-holder p {
        margin: 0;
        font-size: 16px;
        font-family: Vazir-Bold !important;
      }
      .add-button {
        height: 56px;
        border-radius: 24px;
        background: #239ef7;
        color: #fff;
        display: flex;
        align-items: center;
        padding: 0 8px;
        box-sizing: border-box;
      }
      .add-button img {
        padding-left: 8px;
        width: 32px;
        height: 32px;
      }
      .button {
        background: #239ef7;
        height: 56px;
        border-radius: 24px;
        display: inline-flex;
        align-items: center;
        padding: 0 14px;
        color: #fff;
        position: fixed;
        bottom: 24px;
        right: 24px;
        font-size: 20px;
        font-family: 'Vazir-Bold' !important;
      }
      .button img {
        width: 32px;
        height: 32px;
        padding-left: 8px;
      }
    `,
  ],
})
export class CookingStoryTutorialKitchenComponent implements OnInit {
  constructor(private CookingStoryGroceryService: CookingStoryGroceryService) {}
  @Input() type: string;
  dimiss() {
    this.CookingStoryGroceryService.closeTutorial.next(true);
  }
  ngOnInit(): void {}
}
